module.exports = __webpack_public_path__ + "img/picture-13.742ff180.png";